import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import socialPrintTemplateStrings from './contextualStrings';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import { isAlbumFolderParentPay } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    album_type: PropTypes.string.isRequired,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplatePFNoJoinCode = ({ account, albumFolder }) => {
  const stringId = isAlbumFolderParentPay(albumFolder)
    ? 'parentPayMainCopy'
    : 'photoFinderMainCopy';

  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id={stringId}
          defaultMessage="{orgName} is excited to announce we’re offering Waldo’s facial recognition powered mobile app to deliver photos to you! You’ll be able to sit back and relax while Waldo delivers YOUR photos to you and your family members for FREE!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p
        style={{
          padding: '0 17%',
        }}
        className="marketing-material-social-cta-copy"
      >
        Visit our profile page below to view your photos:
      </p>
      <p className="marketing-material-social-target-copy">
        waldophotos.com/@{account.username}
      </p>
    </Fragment>
  );
};

SocialPrintTemplatePFNoJoinCode.propTypes = propTypes;

export default SocialPrintTemplatePFNoJoinCode;
